import { useParams } from "react-router-dom";
import ProfileView from "@/components/ProfileView";
export default function PublicProfile() {
  const { id } = useParams();
  return <ProfileView key={id} userId={id} />;
}
